// export const adminUrl = 'https://admin.megabrandsoutlet.net/admins'
export const adminUrl = 'https://vittoshoes.com/admins'
// export const adminUrl = 'https://alarizmall.com/admins'